document.addEventListener('DOMContentLoaded', () => {
	const canvases = document.querySelectorAll('.js-pattern');

	Array.from(canvases).forEach(canvas => {
		const ctx = canvas.getContext('2d');
		const variances = [];
		const staggers = [];
		const matchMedia = window.matchMedia('(min-width:64em');

		let animationTime = 0;
		let gridSpace = matchMedia.matches ? 16 : 8;
		let rows;
		let cols;

		function resize() {
			canvas.width = canvas.parentElement.clientWidth;
			canvas.height = canvas.scrollHeight;

			gridSpace = matchMedia.matches ? 16 : 8;
			rows = (canvas.height / gridSpace) + 1;
			cols = (canvas.width / gridSpace) + 1;

			// this also needs to be on resize/
			for (i = 0; i < rows; i++) {
				variances[i] = [];
				staggers[i] = [];

				for (j = 0; j < cols; j++) {
					variances[i][j] = Math.floor(Math.random() * 3);
					staggers[i][j] = Math.floor(Math.random() * (rows * cols));

					if (!matchMedia.matches) variances[i][j] = variances[i][j] / 2;
				}
			}
		}

		resize();

		// change to media query change not resize.
		window.addEventListener('resize', resize);

		function isSmallCircle(i, j) {
			return j < 20 || ((j >= 28 && j <= 32 && i >= 5 && i <= rows - 5) || (j >= 40 && j <= 43 && i >= 10 && i <= rows - 5));
		}

		function draw(timestamp) {
			const size = matchMedia.matches ? 8 : 4;
			const baseRadiusStart = matchMedia.matches ? 6 : 3;
			const smallRadiusStart = matchMedia.matches ? 3 : 1.5;
			const factors = matchMedia.matches ? [3, 6] : [1.5, 3];
			const animationFactorMultiplier = 2.3; // essentially speed.

			ctx.clearRect(0, 0, canvas.width, canvas.height);

			animationTime = timestamp ? timestamp / 1000 : 0;

			for (i = 0; i < rows; i++) {
				for (j = 0; j < cols; j++) {
					const y = size + (i * gridSpace);
					const x = size + (j * gridSpace);
					let baseRadius = baseRadiusStart - variances[i][j];

					const shouldIBeSmall = isSmallCircle(i, j);

					if (shouldIBeSmall) baseRadius = smallRadiusStart - variances[i][j];

					const staggerOffset = staggers[i][j] * 0.1;
					const animationFactor = Math.sin((animationTime + staggerOffset) * animationFactorMultiplier) * .5 * .5;

					const factor = shouldIBeSmall ? factors[0] : factors[1];

					const animatedRadius = baseRadius - (factor * animationFactor);

					ctx.beginPath();
					ctx.arc(x, y, animatedRadius, 0, Math.PI * 2);
					ctx.closePath();
					ctx.fillStyle = '#0a1726';
					ctx.fill();
				}
			}

			window.requestAnimationFrame(draw);
		}

		function init() {
			window.requestAnimationFrame(draw);
		}

		init();
	});
});
